export const convertBase64 = (base64Data) => {
  return `data:image/png;charset=utf-8;base64,${base64Data}`;
};
